export default __webpack_public_path__ + "assets/audios/855c0c57d5a2d317d86476105cb57bb9.wav";